import { CommentItem } from "../context/AgreementContext";

let commentIdCounter = 0;

export const createCommentItem = (text = ""): CommentItem => ({
  id: `comment-${Date.now()}-${commentIdCounter++}`,
  text,
  createdAt: new Date().toISOString(),
});

export const getValidComment = (comments: CommentItem[]): CommentItem[] =>
  comments.filter((c) => c.text.trim() !== "");

export const hasUnsavedComments = (comments: CommentItem[]): boolean =>
  comments.some((c) => c.text.trim() !== "");

export const initializeComments = (
  initialComments: CommentItem[],
): CommentItem[] => {
  const filtered = initialComments.filter((c) => c.text.trim() !== "");
  return filtered.length > 0 ? filtered : [createCommentItem()];
};

export const addComment = (comments: CommentItem[]): CommentItem[] => [
  ...comments,
  createCommentItem(),
];

export const removeComment = (
  comments: CommentItem[],
  id: string,
): CommentItem[] => comments.filter((c) => c.id !== id);

export const updateComment = (
  comments: CommentItem[],
  id: string,
  text: string,
): CommentItem[] => comments.map((c) => (c.id === id ? { ...c, text } : c));

export const applyQuickComment = (
  comments: CommentItem[],
  text: string,
): CommentItem[] => {
  const lastComment = comments[comments.length - 1];
  if (lastComment?.text.trim() === "") {
    const updated = [...comments];
    updated[comments.length - 1] = { ...updated[comments.length - 1], text };
    return updated;
  }
  return [...comments, createCommentItem(text)];
};
